/**
 * Primary navigation — 5 tabs (web redesign 2026-07-09).
 * Mirrors iOS RootTab: Today | Watch | Ask | Listen | Discover.
 */

import { featureOwnerForPath } from "./featureRegistry";

export type PrimaryTab = "today" | "watch" | "ask" | "listen" | "discover";

export interface PrimaryTabDef {
  id: PrimaryTab;
  messageKey: string;
  /** Default href when no chart is active. */
  to: string;
  /** Optional glyph for compact mobile bar. */
  glyph: string;
}

export const PRIMARY_TABS: PrimaryTabDef[] = [
  { id: "today", messageKey: "ui.web.primary_nav.today", to: "/", glyph: "☉" },
  { id: "watch", messageKey: "ui.web.primary_nav.watch", to: "/cast", glyph: "◎" },
  { id: "ask", messageKey: "ui.web.primary_nav.ask", to: "/ask", glyph: "✉" },
  { id: "listen", messageKey: "ui.web.primary_nav.listen", to: "/listen", glyph: "♪" },
  { id: "discover", messageKey: "ui.web.primary_nav.discover", to: "/discover", glyph: "✧" },
];

/** Resolve primary tab for a pathname. */
export function primaryTabForPath(pathname: string): PrimaryTab {
  return featureOwnerForPath(pathname);
}

/** Watch-chapter routes still show the 6-chip ChapterNav bezel. */
export function isWatchChapterPath(pathname: string): boolean {
  return primaryTabForPath(pathname) === "watch";
}

/** Build Watch tab destination when a chart is active. */
export function watchHref(chartId?: string | null): string {
  if (chartId) return `/reading/${chartId}`;
  return "/cast";
}

/** Build Today tab destination when a chart is active. */
export function todayHref(chartId?: string | null): string {
  if (chartId) return `/today/${chartId}`;
  return "/";
}

export function listenHref(chartId?: string | null): string {
  return chartId ? `/listen?chart=${encodeURIComponent(chartId)}` : "/listen";
}
